









import { Component, Vue } from 'vue-property-decorator';
import EntityListPage from '@/views/shared/EntityListPage.vue';

@Component({
  components: {
    EntityListPage
  }
})
export default class ListiniPage extends Vue {
  constructor() {
    super();
  }
}
